import * as React from 'react';
import { useContext } from 'react';
import { Grid } from '@material-ui/core';
import { AuthContext } from '../../_auth/AuthContext';
import { IUserState } from '../../_types/user';
import { ColumnDefinition, SearchQuery } from '../../_types/search';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Switch from '@material-ui/core/Switch';
import Button from '@material-ui/core/Button';

import FormControlLabel from '@material-ui/core/FormControlLabel';
import { IChangeEventHandler } from '../../_types/nav';
import { search_param } from '../../_types/search';
import FieldSelector  from './FieldSelector';

interface Props {
    columns: ColumnDefinition[] | null;
    query: SearchQuery | null;
    selectColumn: IChangeEventHandler<string>;
    sortColumn: IChangeEventHandler<string>;
    filterColumn: IChangeEventHandler<string>;
    editFilter: IChangeEventHandler<search_param>;
    doSearch: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
};

const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120
    },
    table: {
        maxHeight: 440
    },
    paper: {
        width: 768
    }
//     home: { color: "primary" },
//     away: { color: theme.palette.grey[900] }
}));

const QueryBuilder: React.FC<Props> = (prop: Props) => {

    const userState: IUserState = useContext(AuthContext);
    const classes = useStyles();

    const isSelected = (cn: string): boolean => {
        let idx = prop.query?.columns.findIndex(g => g === cn);
        let toReturn: boolean = false;

        if (idx !== undefined && idx > -1) {
            toReturn = true;
        }

        return toReturn;
    }

    const availableColumns = (): ColumnDefinition[] => {
        let toReturn: ColumnDefinition[] = [];
        if (prop.columns) {
            let location_id: number | null = null;
            if (userState.user.currentLocation !== undefined && userState.user.currentLocation !== null) {
                location_id = userState.user.currentLocation.id;
            }
            
            prop.columns.forEach(e => {
                if (!e.location_only) {
                    toReturn.push({...e});
                } else {
                    if (location_id !== null) {
                        toReturn.push({...e});
                    }
                }
            });


        } 
        return toReturn;
    }

    const isFiltered = (cn: string): boolean => {
        let idx = prop.query?.queryParams.findIndex(g => g.column_cn === cn);
        let toReturn: boolean = false;

        if (idx !== undefined && idx > -1) {
            toReturn = true;
        }

        return toReturn;
    }
    const filterQuery = (cn: string): search_param | undefined => {
        let toReturn = prop.query?.queryParams.find(g => g.column_cn === cn);
        return toReturn;


    }

    const sortIndex = (cn: string): string => {
        let idx = prop.query?.KeyFields.findIndex(g => g === cn);
        let toReturn = '';

        if (idx !== undefined && idx > -1) {
            toReturn = idx.toString();
        }
;
        return toReturn;
    }

    

    const allowSort = (cn: string): boolean => {
        let toReturn = false;
        if (prop.query?.KeyFields.length === 3) {
            toReturn = prop.query?.KeyFields.indexOf(cn) > -1;
        } else {
            toReturn = true;
        }
        return toReturn;
    }

    const allowFilter= (cn: string): boolean => {

        let toReturn = true;

        if (prop.query && prop.columns) {
            let ccn: string[] = [];
            
            prop.columns.filter(g => g.calculated === true).map(c => ccn.push(c.column_cn));
            //we have calculated columns... can only have one in filter
            if (ccn.length > 0 && prop.query.queryParams.length > 0) {
                
                //are any calculated in current query params
                let currentCalculated = prop.query.queryParams.filter(g => ccn.indexOf(g.column_cn) > -1);
                if (currentCalculated && currentCalculated.length > 1) {
                    let IAmFiltered = currentCalculated.find(g => g.column_cn === cn) != null;
                    toReturn = IAmFiltered || ccn.indexOf(cn) === -1;
                    
                }
            }
        }

        return toReturn;

    }

    return (
        <React.Fragment>
            {prop.columns && (
                <Grid direction="column">
                <Grid item>
                <Paper >
                <TableContainer className={classes.table} >
                    <Table stickyHeader size="small" >
                        <TableHead>
                            <TableRow>
                                <TableCell align="left">Column</TableCell>
                                <TableCell align="left">Include</TableCell>
                                <TableCell align="left">Sort</TableCell>
                                <TableCell align="left">Filter</TableCell>
                                <TableCell align="left">Filter On</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {availableColumns().map(c => (
                                <TableRow key={c.column_cn}>
                                    <TableCell align="left">{c.friendly_name} {c.calculated ? " (calculated) " : ""}</TableCell>
                                    <TableCell align="left">
                                        <Switch color="primary" checked={isSelected(c.column_cn)} 
                                            onChange = {(event: React.ChangeEvent<HTMLInputElement>) => { prop.selectColumn(c.column_cn); }}
                                        />
                                    </TableCell>
                                    <TableCell align="left">
                                        { (c.sortable && allowSort(c.column_cn)) && (
                                        <FormControlLabel label={sortIndex(c.column_cn)}
                                        control = {
                                        <Switch color="primary"  checked={sortIndex(c.column_cn) !== ''}
                                            onChange = {(event: React.ChangeEvent<HTMLInputElement>) => { prop.sortColumn(c.column_cn); }}
                                        />}/>
                                        )
                                        }
                                    </TableCell>
                                    <TableCell align="left">
                                        { (c.queryable && allowFilter(c.column_cn)) && (
                                        <Switch color="primary" checked={isFiltered(c.column_cn)}
                                        onChange = {(event: React.ChangeEvent<HTMLInputElement>) => { prop.filterColumn(c.column_cn); }}                                           
                                        />)}
                                    </TableCell>
                                    <TableCell align="left">
                                        { (isFiltered(c.column_cn) && filterQuery(c.column_cn) !== undefined) && 
                                        (<FieldSelector searchParam={filterQuery(c.column_cn) as search_param} onChange={prop.editFilter} selector_cn={c.selector_cn} />)}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                </Paper>

                </Grid>
                <Grid item>
                    <Button variant="outlined" onClick={prop.doSearch}>Search</Button>
                </Grid>
                </Grid>
            )}
        </React.Fragment>
    )

}

export default QueryBuilder;